<template>
  <div>
    <v-menu
      v-model="statusMenu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :class="actionPermission.class"
          v-on="on"
          rounded
        >
          {{ actionPermission.name }}
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="status in refNpaStatus"
          :key="status.id"
          @click="openForm(status)"
          two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ status.transName }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog
      v-model="npaStatusDialog"
      scrollable
      max-width="600px"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t("Результат проекта НПА") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form
            action
            @submit.prevent="save"
          >
            <div class="form-group">
              <label>
                Статус
                <span class="asterix">*</span>
              </label>
              <v-text-field
                v-model="status.transName"
                readonly
                outlined
                rounded
                dense
                disabled
              />
            </div>
            <div class="form-group" v-if="status.adoption_date">
              <label>
                {{ $t("Дата принятия") }}
              </label>
              <v-menu
                v-model="menuDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="npaStatus.dateAccept"
                    readonly
                    v-on="on"
                    outlined
                    rounded
                    dense
                  />
                </template>
                <v-date-picker
                  v-model="npaStatus.dateAccept"
                  :weekday-format="getDay"
                  :month-format="getMonthFormat"
                  :header-date-format="getHeaderDateFormat"
                  no-title
                  first-day-of-week="1"
                />
              </v-menu>
            </div>
            <div class="form-group" v-if="status.comment">
              <label>
                {{ $t("Комментарии") }}
              </label>
              <v-textarea
                outlined
                auto-grow
                rounded
                rows="1"
                v-model="npaStatus.comment"
                full-width
                class="complaint-form-text"
              />
            </div>
            <div class="form-group" v-if="status.npa_link">
              <label>
                {{ $t("Ссылка НПА") }}
              </label>
              <v-text-field
                v-model="npaStatus.link"
                outlined
                rounded
                dense
              />
            </div>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">{{ $t("Сохранить") }}</v-btn>
          <v-btn @click="cancel">{{ $t("Отмена") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay absolute :value="loading">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>
  </div>
</template>

<script>
  import Npa from '@/model/npa'
  import { required } from 'vuelidate/lib/validators'
  import mixin from '@/plugins/mixin/mixin'

  export default {
    mixins: [mixin],
    props: {
      npa: Object,
      actionPermission: Object
    },
    data: () => ({
      refNpaStatus: null,
      npaStatus: {
        status: null,
        dateAccept: null,
        comment: null,
        link: null
      },
      menuDate: null,
      loading: false,
      menu: false,
      statusMenu: false,
      status: {},
      npaStatusDialog: false
    }),
    methods: {
      openForm (status) {
        this.status = status
        this.npaStatusDialog = true
        this.statusMenu = false
      },
      cancel () {
        this.npaStatusDialog = false
        this.status = {}
        this.npaStatus = {}
      },
      save () {
        this.npaStatus.status = this.status.id
        this.loading = true

        Npa.saveNpaResult(this.npa.id, { npa_result: this.npaStatus }).then((response) => {
          this.loading = false
          this.npaStatus = {}
          this.npaStatusDialog = false
          this.$emit('saveResult', response.data)
        })
      }
    },
    async mounted () {
      Npa.getNpaResultData(this.npa.id).then((response) => {
        this.refNpaStatus = response.data.refNpaStatus
      })
    }
  }
</script>

<style lang="scss" scoped>
  .v-menu__content {
    .v-list {
      .v-list-item {
        min-height: 10px;
      }
    }
  }
</style>
